export default "__VITE_ASSET__B19x50B3__"